import type { HistoryObjectType } from '@iotv/iotv-v3-types'
import type { TimeBucketType } from '../../../util/time/Periodization/types'

export enum BucketStrategy {
  /** For count-like attributes, where count since last reading should be apportioned across preceding buckets */
  APPORTION = 'APPORTION',
  /** For reading-like attributes ( eg temperature), where the values going into one bucket as essentially averaged, and for intervening buckets should be inferred by some regression strategy */
  INFERREADING = 'INFERREADING',
  /** Maximums, for example max temperature */
  MAXIMUM = 'MAXIMUM',
  /** Minimum */
  MINIMUM = 'MINIMUM',
}

export type InferReadingInput = {
  timeBucketDef: TimeBucketType
  k: string
  v: number
  startTimestamp: number
  endTimestamp: number
}

export type AutoBucketHistoryProps = {
  timeBucketDef: TimeBucketType
  historyStoreProps?: Partial<HistoryObjectType>
  bucketStrategyMap?: { [key: string]: BucketStrategy }
  defaultBucketStrategy?: BucketStrategy
}
